export const COMPETITIONS_REQUEST = 'competitionsRequest';
export const COMPETITIONS_FAILURE = 'competitionsFailure';
export const COMPETITIONS_SUCCESS = 'competitionsSuccess';
